module.exports = __webpack_public_path__ + "img/meeting&event.29df7e14.svg";